import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["passwordInput", "toggleIcon"]
  }

  togglePassword(e) {
    const isPassword = this.passwordInputTarget.type === "password";
    this.passwordInputTarget.type = isPassword ? "text" : "password";

    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.toggle("tw-text-jazzberry", isPassword);
      this.toggleIconTarget.classList.toggle("tw-text-gray-400", !isPassword);

      const showLabel = this.element.dataset.togglePasswordShowLabel;
      const hideLabel = this.element.dataset.togglePasswordHideLabel;
      if (showLabel && hideLabel) {
        this.toggleIconTarget.setAttribute("aria-label", isPassword ? hideLabel : showLabel);
      }
    }
  }
}
